import { CheckCircleOutlined, EditOutlined, StopOutlined} from "@ant-design/icons";
import { PageHeader, Checkbox, Popconfirm, message, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem, dineroDisabledMask, SegmentedItem } from "../../../Components/Items";
import HeaderActions from "../../../Components/HeaderActions";
import AgregarBanco from "./AgregarBanco/AgregarBanco";
import EditarBanco from "./EditarBanco/EditarBanco";
import Balance from "../../../Icons/balance";

class Bancos extends Component {
  state = {
    todasBancos: [],
    modalAgregarBanco: false,
    modalEditarBanco: false,
    modalEditarBancoId: null,
    loading: false,
    valor: 1,
  };
  componentDidMount() {
    this.consultarBancos(this.state.valor);
  }

  consultarBancos(valor) {
    this.setState({ loading: true })
    axios
      .post(
        "bancos/selectTodosBancos",
        { empresaId: this.props.empresaId, valor: valor },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.status === 404) {
          this.setState({ todasBancos: [] });
        } else {
          this.setState({
            todasBancos: res.data.map(value => {
              return { ...value, accion: { _id: value._id, nombre: value.nombre, estado: value.estado } }
            }),
          });
        }
      });
  }

  abrirAgregarBanco() {
    this.setState({ modalAgregarBanco: true });
  }
  cerrarAgregarBanco() {
    this.setState({ modalAgregarBanco: false });
    this.consultarBancos(this.state.valor);
  }
  abrirEditarBanco(id) {
    this.setState({ modalEditarBanco: true, modalEditarBancoId: id });
  }
  cerrarEditarBanco() {
    this.setState({ modalEditarBanco: false });
    this.consultarBancos(this.state.valor);
  }
  deshabilitarBanco(value) {
    axios
      .post(
        "bancos/deshabilitarBanco",
        { bancoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Banco deshabilitado");
        } else {
          message.error("Sucedio un eror y no se pudo deshabilitar");
        }
        this.consultarBancos(this.state.valor);
      });
  }
  habilitarBanco(value) {
    axios
      .post(
        "bancos/habilitarBanco",
        { bancoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Banco habilitado");
        } else {
          message.error("Sucedio un eror y no se pudo habilitar");
        }
        this.consultarBancos(this.state.valor);
      });
  }
  abrirTraspasoEntreCuentas() {
    this.props.history.push('/panel/traspasoEntreCuentas')
  }
  abrirConciliarCuenta(id, nombre) {
    this.props.history.push('/panel/conciliarCuenta', { id, nombre })
  }
  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
      },
      {
        title: "Banco",
        dataIndex: "banco",
        key: "banco",
        responsive: ["md"],
        sorter: (a, b) => {
          if (a.banco < b.banco) {
            return -1;
          }
          if (a.banco > b.banco) {
            return 1;
          }
          return 0;
        },
        buscar: "banco",
      },

      {
        title: "Moneda",
        dataIndex: "moneda",
        key: "moneda",
        responsive: ["md"],
        render: (value) => (value.abreviacion + " - " + value.nombre)
      },

      {
        title: "Es inversión",
        dataIndex: "inversion",
        key: "inversion",
        responsive: ["md"],
        render: (value) => <Checkbox checked={value} />,
        align: "center",
      },
      {
        title: "Saldo",
        dataIndex: "saldo",
        key: "saldo",
        render: (value) => dineroDisabledMask(value)
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "18%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record, index) => {
          let buttons = [];

          if (this.props.permisoEditarBancos) {
            buttons.push(
              <Tooltip title="Editar Banco" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${index}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.abrirEditarBanco(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          if (this.props.permisoDeshabilitarBanco) {
            if (value.estado === 1) {
              buttons.push(
                <Popconfirm
                  key={`deshabilitar-${index}`}
                  title="Seguro que quieres deshabilitar este banco"
                  onConfirm={() => this.deshabilitarBanco(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      lima
                      icon={<CheckCircleOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm
                  key={`habilitar-${index}`}
                  title="Seguro que quieres habilitar este banco"
                  onConfirm={() => this.habilitarBanco(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      rojo
                      icon={<StopOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            }
          }

          // Botón Conciliar Cuenta
          if (this.props.permisoConciliarCuenta) {
            buttons.push(
              <Tooltip title="Conciliar Cuenta" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`conciliar-${index}`}
                  type='primary'
                  size='small'
                  naranja
                  icon={<span style={{ fontSize: '16px', display: 'flex', alignItems: 'center' }}><Balance size={16} stroke={2.5} /></span>}
                  onClick={() => this.abrirConciliarCuenta(value._id, value.nombre)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ]
    return (
      <>
        <PageHeader
          title="Bancos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            
                {window.innerWidth > 1000 &&
                  <SegmentedItem
                    options={[{ label: 'Activo', value: 1 }, { label: 'Deshabilitado', value: 2 }, { label: 'Todos', value: 3 }]}
                    onChange={(value) => {
                      this.consultarBancos(value)
                      this.setState({ valor: value })
                    }}
                    value={this.state.valor}
                  />
                }
              <HeaderActions>
                {this.props.permisoTraspasoEntreCuentas &&
                  <ButtonItem
                    cyan
                    key="traspaso"
                    onClick={this.abrirTraspasoEntreCuentas.bind(this)}
                  >
                    Traspaso entre Cuentas
                  </ButtonItem>
                }
              </HeaderActions>

              {this.props.permisoAgregarBancos &&
                <ButtonItem
                  type="primary"
                  olivo
                  key="agregarBanco"
                  onClick={this.abrirAgregarBanco.bind(this)}
                  style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                >
                  Agregar Banco
                </ButtonItem>
              }
            </div>
          }
        />
        <TableItem size='small' loading={this.state.loading} dataSource={this.state.todasBancos} columns={columns} onRow={(record) => ({
            onDoubleClick: () => {
              if (this.props.permisoEditarBancos) {
                this.abrirEditarBanco(record.accion._id);
              }
            },
          })}/>
        {this.props.permisoAgregarBancos &&
          <AgregarBanco
            visible={this.state.modalAgregarBanco}
            cerrarAgregarBanco={this.cerrarAgregarBanco.bind(
              this
            )}
          />
        }
        {this.props.permisoEditarBancos &&
          <EditarBanco
            id={this.state.modalEditarBancoId}
            visible={this.state.modalEditarBanco}
            cerrarEditarBanco={this.cerrarEditarBanco.bind(
              this
            )}
          />
        }
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarBancos: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ca4b4f30e81b54183cf4a")?.activado,
    permisoEditarBancos: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ca360f30e81b54183cf49")?.activado,
    permisoTraspasoEntreCuentas: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ca538f30e81b54183cf4b")?.activado,
    permisoDeshabilitarBanco: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ca591f30e81b54183cf4c")?.activado,
    permisoConciliarCuenta: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "67508e27798d4e0043687237")?.activado
  };
};

export default connect(mapStateToProps)(Bancos);
